export const MENU_ITEMS_PANEL_EXPANDED_WIDTH = 320;
export const MENU_ITEMS_PANEL_COLLAPSED_WIDTH = 40;
